import * as yup from 'yup';

export const schema = yup.object({
  name: yup.string().required('必須です'),
  address: yup.string().required('必須です')
});
